/**
 * Report groups API (2026-10-23) — ``/api/builder/report-groups``.
 *
 * A group is N reports of one project (its tabs) that share ONE filter
 * set; the group page (UI3) edits, per filter and per report, whether the
 * report USES it (at which column) or it does NOT APPLY. A «falta» cell
 * blocks the publish. A group is made by switching its project to tabs
 * (``project-mode-api``), never on its own.
 */
import { api } from "@/lib/api";
import type { ReportGroup } from "@/types";

export interface ReportGroupUpdatePayload {
  display_name?: unknown;
  config?: ReportGroup["config"];
  /** Report keys in tab order. */
  members?: string[];
}

export const reportGroupsApi = {
  list: (projectId?: string) =>
    api.get<{ groups: ReportGroup[] }>("/api/builder/report-groups", {
      query: { project_id: projectId },
    }),
  get: (key: string) => api.get<ReportGroup>(`/api/builder/report-groups/${key}`),
  update: (key: string, payload: ReportGroupUpdatePayload) =>
    api.put<ReportGroup>(`/api/builder/report-groups/${key}`, payload),
  /** ``confirmBrokenViews``: the person saw the saved AI Home views this
   *  publish breaks (the server's 409) and publishes anyway. */
  publish: (key: string, confirmBrokenViews = false) =>
    api.post<ReportGroup>(
      `/api/builder/report-groups/${key}/publish`,
      confirmBrokenViews ? { confirm_broken_views: true } : undefined,
    ),
  remove: (key: string) => api.delete<void>(`/api/builder/report-groups/${key}`),
};
